module.exports = __webpack_public_path__ + "static/PrintPattern-501bf4fa26909e5a94bfbb875ae57731.png";